import { useRoles } from "src/context/roles-context";

import { PiRoadHorizonDuotone } from "react-icons/pi";

import { useRateCalculator } from "../context/rate-calculator-state";
import { RateRibbon } from "../components/rate-ribbon";
import { Instruction } from "src/components/instruction";
import { LeftSidebar } from "src/components/left-sidebar";
import { HistoryTable } from "../components/history-table";
import { CalculatorForm } from "src/apps/rate-calculator/components/calculator-input";
import { formatCurrency } from "src/types/number";
import { PageBase } from "src/components/page-base";

export function IndexPage() {
    const roles = useRoles();
    const accessRC = roles.checkHasRole("BidRateCalculator.Write");
    const rateCalculatorState = useRateCalculator();

    const laneName =
        rateCalculatorState.currentRateData?.rateHistoryAvgOfLane_PerCustomer[0]
            .lane;
    const laneAverage =
        rateCalculatorState.currentRateData?.rateHistoryAvgOfLane;
    const laneAvgAllIn =
        (laneAverage?.linehaul ?? 0) + (laneAverage?.fuel ?? 0);

    const AppName = "Rate Calculator";

    return (
        <>
            <PageBase pageName={AppName} userPermitted={accessRC}>
                <>
                    <LeftSidebar
                        title={AppName}
                        icon={
                            <PiRoadHorizonDuotone className="w-8 h-8 mr-2 text-[#ac2226]" />
                        }
                    >
                        <CalculatorForm />
                    </LeftSidebar>

                    <div className="flex-1 flex flex-col overflow-hidden p-8 gap-8">
                        {rateCalculatorState.loading ||
                        rateCalculatorState.loadingHistory ||
                        rateCalculatorState.avrlBidRate != null ||
                        rateCalculatorState.currentRateData != null ? (
                            <div className="flex flex-1 flex-col gap-6">
                                <RateRibbon
                                    laneData={
                                        rateCalculatorState.currentRateData
                                            ?.laneData ?? null
                                    }
                                    currentBidRates={
                                        rateCalculatorState.avrlBidRate
                                    }
                                    calcDetails={
                                        rateCalculatorState.avrlBidCalc
                                    }
                                    loading={rateCalculatorState.loading}
                                />

                                <HistoryTable
                                    lane={laneName ?? "Error"}
                                    avgAllIn={formatCurrency(laneAvgAllIn)}
                                    avgLineRev={formatCurrency(
                                        laneAverage?.linehaul,
                                    )}
                                    avgFuelRev={formatCurrency(
                                        laneAverage?.fuel,
                                    )}
                                    avgRPM={formatCurrency(laneAverage?.rpm)}
                                    avgFuelRate={formatCurrency(
                                        laneAverage?.fuelRate,
                                    )}
                                    avgBilledMiles={(
                                        laneAverage?.billed_miles ?? 0
                                    ).toFixed(0)}
                                    icon={
                                        <PiRoadHorizonDuotone className="w-16 h-16 text-[#ac2226]" />
                                    }
                                    data={rateCalculatorState.currentRateData}
                                    loading={rateCalculatorState.loadingHistory}
                                    loadError={false}
                                    errorTitle="Whoops!"
                                    errorText="Something went wrong, please try again later."
                                    emptyTitle="Nothing Here"
                                    emptyText="This lane is not a traditional lane fit for MVT."
                                />
                            </div>
                        ) : (
                            <Instruction
                                title="No Route Defined Yet"
                                description="Use the sidebar to specify the origin and destination of your route to begin."
                                icon={
                                    <PiRoadHorizonDuotone className="w-8 h-8 text-[#ac2226]" />
                                }
                            />
                        )}
                    </div>
                </>
            </PageBase>
        </>
    );
}
